
import React from "react"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { useState } from 'react';
import { setErrorMessage } from "../tools/errorhandling";
import PDFFILE from '../customNodes/invoice-pdf'
import { PDFDownloadLink, Page, StyleSheet, Text, Document, Image, Font, View } from '@react-pdf/renderer'
import moment from "moment";
import { styles } from "../customNodes/invoice-pdf";
import { render } from 'react-dom';
import Button from 'react-bootstrap/Button';
import HotelSelection from '../customNodes/HotelSelection';
import hotelcss from './css/hotelhotellist.module.css';
import {
    getserverurl, getvariabletable, getallhotels, gethotel, getView
} from "../dbconnector/connector";



const extraFunctie = () => {

}



const Invoice = (props) => {


    const t = props.translation
    const [invoicearray, setinvoicearray] = useState([]);
    const [invoiceTotalarray, setinvoiceTotalarray] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [invoicesAD, setInvoicesAD] = useState([]);
    const [general, setGeneral] = useState([]);
    const [selectedHotel, setselectedHotel] = useState([]);
    const [billingperiod, setBillingperiod] = useState([]);
    let allprocessed = 0
    let totalinvoicedamount = 0;

    const [mededeling, setmededeling] = useState("+++029/2254/48076+++");

    //const [cleaningtypes, setcleaningtypes] = useState([]);

    //t("CheckIn")
    // create navigation object if needed
    const navigate = useNavigate();



    //dop something after loading page
    useEffect(() => {
        //console.log("LOADING DATA")

        //console.log("selectedHotel.Hotel_ID = ", selectedHotel.Hotel_ID)
        if (selectedHotel.Hotel_ID !== undefined) {
            LoadGeneral();
            //const arra = ["1", "2", "3", "4", "5"]
            setinvoicearray([])
            setinvoiceTotalarray([])
            setInvoices([])
            allprocessed = 0;
            totalinvoicedamount = 0;
            const fields = `["hotel_Id","billingperiod"]`;
           console.log( "selected billing period :" , document.getElementById("billingperiod").value)
            const values = `[${selectedHotel.Hotel_ID},"${document.getElementById("billingperiod").value}"]`;
            console.log("values : ", values)
            console.log("fields : ", fields)
            getView("createinvoicedata", fields, values).then(res => {
                if (res.status === 200) {
                    // console.log("createinvoicedata :")
                    res.json().then(body => {
                        console.log("createinvoicedata :", body)
                        setInvoices(body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
            setInvoicesAD([])

            const fields2 = '["HotelID"]';
            const values2 = `[${selectedHotel.Hotel_ID}]`;

            getView("hotelgenerals", fields2, values2).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        console.log("hotelgenerals :", body)
                        setInvoicesAD(body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
            buildTotal();
        }

    }, [selectedHotel, billingperiod]);

    useEffect(() => {
        if (invoices.length > 0) {
            buildinvoicepart("KAMERS BLIJVERS", 0)
            buildinvoicepart("KAMERS VERTREKKERS", 1)
            buildinvoicepart("FLITS KAMERS", 2)
            buildinvoicepart("Dagelijkse schoonmaak", 3)
            buildinvoicepart("Wekelijkse schoonmaak", 4)
            buildinvoicepart("Eindschoonmaak", 5)
            allprocessed = allprocessed + 1
        }
    }, [invoices]);

    useEffect(() => {
        if (invoicesAD.length > 0) {
            setinvoicearray(pre => [...pre,
            <View style={styles.Rowgrey}>
                <Text style={styles.tabletitle}>Publieke ruimtes per maand</Text>
            </View>
            ]);
            invoicesAD.forEach((item, index) => {
                let algemenedienst = 0
                if (item.algemenedienst > 0) {
                    algemenedienst = item.algemenedienst / 2
                }
                totalinvoicedamount = totalinvoicedamount + Number(algemenedienst)
                setinvoicearray(pre => [...pre,
                <View style={styles.Rowwhite}>
                    <Text style={styles.row_colA_1}>2-wekelijks</Text>
                    <Text style={styles.row_colB_1}>1</Text>
                    <Text style={styles.row_colC_1}>€ {algemenedienst}</Text>
                    <Text style={styles.row_colD_1}>0%</Text>
                    <Text style={styles.row_colE_1}>€ {algemenedienst}</Text>
                </View>

                ])
            })
        }
        allprocessed = allprocessed + 1

    }, [invoicesAD]);
    useEffect(() => {
        // console.log("allprocessed = ")
        if (allprocessed === 2) {
            //   console.log("processed going to total ")
            buildTotal(totalinvoicedamount)
        }

    }, [allprocessed]);

    const buildinvoicepart = (partname, partnumber) => {
        const part = invoices.filter(element => {
            if (element.type === partnumber) {
                return element
            }
        })
        //console.log(partname, " =", part)
        if (part.length > 0) {
            setinvoicearray(pre => [...pre,
            <View style={styles.Rowgrey}>
                <Text style={styles.tabletitle}>{partname}</Text>
            </View>
            ]);
            part.forEach((item, index) => {
                totalinvoicedamount = totalinvoicedamount + Number(item.totaal)
                //console.log(totalinvoicedamount)
                setinvoicearray(pre => [...pre,
                <View style={index % 2 === 0 ? styles.Rowwhite : styles.Rowgrey}>
                    <Text style={styles.row_colA_1}>{item.daytypedescription}</Text>
                    <Text style={styles.row_colB_1}>{item.aantal}</Text>
                    <Text style={styles.row_colC_1}>€ {item.stukprijs}</Text>
                    <Text style={styles.row_colD_1}>0%</Text>
                    <Text style={styles.row_colE_1}>€  {item.totaal}</Text>
                </View>
                ])
            })
            if (part.length === 2) {
                setinvoicearray(pre => [...pre,
                <View style={styles.Rowwhite}>
                    <Text style={styles.row_colA_1}></Text>
                    <Text style={styles.row_colB_1}></Text>
                    <Text style={styles.row_colC_1}></Text>
                    <Text style={styles.row_colD_1}></Text>
                    <Text style={styles.row_colE_1}></Text>
                </View>
                ])
            }
        }

    }
    const buildTotal = (total) => {
        //console.log("total :", total)
        //console.log("totalinvoicedamount :" , totalinvoicedamount)
        setinvoiceTotalarray(pre => [...pre,
        <View style={styles.blackline}>
        </View>
        ])
        setinvoiceTotalarray(pre => [...pre,
        <View style={styles.Rowsubtotal}>
            <Text style={styles.row_subtotalempty}></Text>
            <Text style={styles.row_subtotaldesc}>Totaal excl. btw</Text>
            <Text style={styles.row_subtotal}>€ {total}</Text>
        </View>
        ])
        setinvoiceTotalarray(pre => [...pre,
        <View style={styles.Rowsubtotal}>
            <Text style={styles.row_subtotalempty}></Text>
            <Text style={styles.row_subtotaldesc}>Btw 0%</Text>
            <Text style={styles.row_subtotal}>€ 0,00</Text>
        </View>
        ])
        setinvoiceTotalarray(pre => [...pre,
        <View style={styles.Rowsubtotal}>
            <Text style={styles.row_subtotalempty}></Text>
            <Text style={styles.row_subtotaldesc}>Totaal incl. btw</Text>
            <Text style={styles.row_subtotal}>€  {total}</Text>
        </View>
        ])
        setinvoiceTotalarray(pre => [...pre,
        <View style={styles.Rowtotal}>
            <Text style={styles.row_subtotalempty}></Text>
            <Text style={styles.row_totaldesc}>Totaal te betalen</Text>
            <Text style={styles.row_total}>€  {total}</Text>
        </View>])
    }
    const LoadGeneral = () => {
        setGeneral([]);
        const fields = null;
        const values = null;
        getView("shcview", "id", 4).then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    console.log("shcview : ", body)
                    setGeneral(body[0])
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })

    }
    const setbillingperiod =  (e) => {

        setBillingperiod(e.target.value)
    }
    const setSelectedHotel = (e) => {
        ////console.log("hotelid = ", e.target.value)
        gethotel(e.target.value).then(res => {
            if (res.status === 200) {
                //      //console.log("hotel", res.hotel)
                setselectedHotel(res.hotel)
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }
    function addDays(date, days) {
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    }
    const createInvoice = (e) => {
        //console.log("selectedHotel :", selectedHotel)
        //console.log("general : ", general)
        const invoice = new Blob([<PDFFILE data={{ date: moment().toDate().toDateString(), hotelid: selectedHotel.Hotel_ID, addresto: { naam: selectedHotel.Name, contactpersoon: "Christophe Prims" }, testarray: invoicearray, invoiceTotalarray: invoiceTotalarray }} />])
    }

    useEffect(() => {
        // const invoice= new Blob([<PDFFILE  data={{ date: moment().toDate().toDateString(), hotelid: "1668", addresto:{naam:"NV Le Bois De Bruges", contactpersoon:"Christophe Prims"} , testarray:invoicearray}}  />])
        // ////console.log(invoice)
        // setInvoice( URL.createObjectURL(invoice))
    }, [invoicearray])

    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                </header>
                <div className="form" id="adminfilterbox">
                    <label className='formtitleContentBox'>{t('filterinstellingen')}</label>
                    <br></br>
                    <div className="contentbox ">
                        <div id="searchbox" className="formElement">
                            <label className='labelcolor'>
                                {t('Hotel')}:
                            </label>
                            <HotelSelection isDisabled={false} data={{ fieldname: "nr_afd", selectedhotel: null, handleitemchange: setSelectedHotel }} valueneeded="hotel_id" />
                        </div>
                        <div id="searchbox" className="formElement">
                            <label className='labelcolor'>
                                {t('Billing period')}:
                            </label>
                            <select id="billingperiod" onChange={setbillingperiod}>
                                <option value="2025-4-02">2025-april-02</option>
                                <option value="2025-5-01">2025-mei-01</option>
                                <option value="2025-5-02">2025-mei-02</option>
                                <option value="2025-6-01">2025-juni-01</option>
                                <option value="2025-6-02">2025-juni-02</option>
                                <option value="2025-7-01">2025-juli-01</option>
                                <option value="2025-7-02">2025-juli-02</option>
                            </select>
                        </div>
                        {/* <div id="searchbox" className="formElement">
                            <label className='labelcolor'>
                                {t('StartDate')}:
                            </label>
                            <input type="date" id="scheduledate" defaultValue={addDays(new Date(), -14).toLocaleDateString('en-CA')}></input>

                        </div>
                        <div id="searchbox" className="formElement">
                            <label className='labelcolor'>
                                {t('endDate')}:
                            </label>
                            <input type="date" id="scheduledate" defaultValue={addDays(new Date(), 0).toLocaleDateString('en-CA')}></input>

                        </div> */}
                        <div id="boxinvoice" className="formElement">
                            <label className='labelcolor'>
                            </label>
                            {/* <Button id="createInvoice" onClick={createInvoice}>{t('Create invoice')}</Button> */}

                            <PDFDownloadLink document={<PDFFILE
                                data={{ date: moment().toDate().toDateString(), fromdata: general, todata: selectedHotel, testarray: invoicearray, mededeling: mededeling, invoiceTotalarray: invoiceTotalarray }}

                            />} fileName="FORM">
                                {({ loading }) => (loading ? <button>Loading document ....</button> : <button>Download</button>)}
                            </PDFDownloadLink>
                        </div>
                        <br></br>
                    </div>

                </div>
                {/* <div id="content">
                    <PDFDownloadLink document={<PDFFILE
                        data={{ date: moment().toDate().toDateString(), fromdata: general, todata: selectedHotel, testarray: invoicearray, mededeling: mededeling }}

                    />} fileName="FORM">
                        {({ loading }) => (loading ? <button>Loading document ....</button> : <button>Download</button>)}
                    </PDFDownloadLink>
                </div> */}

                <div id="listofcreatedinvoices" className="form" >
                    <div id="headertable" className={hotelcss.invoiceslist_tableheader}><p id="HotelName">{t('Name')}</p><p id="Fromdate">{t('From')}</p><p id="ToDate">{t('To')}</p><p id="SendByMail">{t('SendByMail')}</p><p id="DowndLoad">{t('Download')}</p><p id="Resend">{t('Resend')}</p></div>
                    <div id="resultlist" className='list'>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Invoice